import {ButtonHTMLAttributes, ReactElement, ReactNode} from "react";
import {omit} from "ramda";

export interface PrimaryButtonProps {
    children: ReactNode
}

export function PrimaryButton(props: PrimaryButtonProps & ButtonHTMLAttributes<HTMLButtonElement>): ReactElement {
    const restAttributes = omit(["children", "className"], props);
    return (
        <button className="bg-primary rounded-full px-4 py-2
                           text-white font-barlow font-semibold leading-none
                           cursor-pointer
                           disabled:bg-gray-1 disabled:cursor-default relative"
                {...restAttributes}>
            {props.children}
        </button>
    );
}